import { Badge } from 'components/ui/badge';
import { getClassifierText } from 'utils/getTranslations.ts';
import { useClassifiers } from 'utils/useClassifiers.ts';

interface StatusChipProps {
    segmentTypeCode?: string;
}

/** The contact's segment as a tag with a pointed right edge. Every segment shares one colour. */
export default function SegmentChip({ segmentTypeCode }: StatusChipProps) {
    const { classifiers } = useClassifiers({ codes: ['SEGMENT_TYPE'] });

    return (
        <div className="flex flex-row">
            <Badge className="bg-info/14 text-info new:bg-neutral-tint new:text-foreground-secondary h-auto min-h-6 min-w-6 self-end rounded-sm rounded-r-none px-2 py-px text-xs leading-5 font-semibold">
                {getClassifierText(classifiers['SEGMENT_TYPE'], segmentTypeCode)}
            </Badge>
            <div className="border-l-info/14 new:border-l-neutral-tint size-0 border-y-12 border-l-6 border-y-transparent" />
        </div>
    );
}
